/**
 * This file was auto-generated by Fern from our API Definition.
 */

export type PresentationIssueRequestCompositionType = 'EMBED';
export const PresentationIssueRequestCompositionType = {
    Embed: 'EMBED',
} as const;
